module.exports = __webpack_public_path__ + "assets/img/AuthState.f8fdc4fa.svg";